// Client book, page 7: the address text says 696, while its map says 693.
// Until the client confirms the house number, show the avenue/region only.
// Google Maps searches intentionally do not assert a precise building pin.
export const developmentLocation = {
  id: "urban-square",
  name: "Urban Square",
  area: "Neoville · Curitiba",
  address: "Av. das Indústrias · Neoville, Curitiba",
  query: "Avenida das Indústrias Neoville Curitiba PR",
  mapLabel: "Avenida das Indústrias · região do empreendimento",
  description: "Educação, comércio, mobilidade e áreas de lazer fazem parte da região. Um endereço para viver o Neoville com mais praticidade.",
  source: "book_vendas_sanches_urban_tower_16_06_2026_v4_Nova_Foto.pdf, página 7",
  addressPending: true,
};

export const nearbyCategories = [
  { id: "todos", label: "Todos" },
  { id: "educacao", label: "Educação" },
  { id: "mobilidade", label: "Mobilidade" },
  { id: "compras", label: "Compras" },
  { id: "saude", label: "Saúde" },
  { id: "lazer", label: "Lazer" },
];

// Primary sources checked 2026-09-10. These are regional points of interest;
// no walking proximity, travel times or distance estimates are asserted.
export const nearbyPlaces = [
  {
    id: "utfpr-neoville",
    name: "UTFPR · Sede Neoville",
    category: "educacao",
    detail: "Universidade e formação acadêmica",
    address: "Rua Pedro Gusso, 2601 · Neoville",
    query: "UTFPR Sede Neoville Rua Pedro Gusso 2601 Curitiba",
    source: "https://www.utfpr.edu.br/campus/curitiba/contatos",
  },
  {
    id: "senai-cic",
    name: "SENAI · Curitiba CIC",
    category: "educacao",
    detail: "Educação profissional e tecnologia",
    address: "Rua Senador Accioly Filho, 298 · Cidade Industrial",
    query: "SENAI Curitiba CIC Rua Senador Accioly Filho 298 Curitiba",
    source: "https://transparencia.senaipr.org.br/web/senai-pr-portal-da-transparencia/w/curitiba-cic-1",
  },
  {
    id: "condor-joao-bettega",
    name: "Condor João Bettega",
    category: "compras",
    detail: "Supermercado e compras do dia a dia",
    address: "Rua João Bettega, 3930 · Cidade Industrial",
    query: "Super Condor João Bettega Rua João Bettega 3930 Curitiba",
    source: "https://institucional.condor.com.br/lojas_/super-condor-joao-bettega/",
  },
  {
    id: "terminal-cic",
    name: "Terminal CIC",
    category: "mobilidade",
    detail: "Transporte integrado",
    address: "Rua Pedro Gusso, 3840 · Cidade Industrial",
    query: "Terminal CIC Rua Pedro Gusso 3840 Curitiba",
    source: "https://locais.curitiba.pr.gov.br/terminal-cic/509",
  },
  {
    id: "us-oswaldo-cruz",
    name: "Unidade de Saúde Oswaldo Cruz",
    category: "saude",
    detail: "Atendimento de saúde na região",
    address: "Rua Pedro Gusso, 3749 · Cidade Industrial",
    query: "Unidade de Saúde Oswaldo Cruz Rua Pedro Gusso 3749 Curitiba",
    source: "https://locais.curitiba.pr.gov.br/unidade-de-saude-oswaldo-cruz/622",
  },
  {
    id: "parque-linear-capao-raso",
    name: "Parque Linear Capão Raso",
    category: "lazer",
    detail: "Ciclovia e espaços de lazer no Neoville",
    address: "Região do Neoville · Curitiba",
    query: "Parque Linear Capão Raso Neoville Curitiba",
    source: "https://www.curitiba.pr.gov.br/noticias/meio-ambiente-vai-ao-neoville-para-discutir-novas-acoes-contra-as-mordeduras-de-caes/67510",
  },
];

export function mapSearchUrl(query) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

export function mapEmbedUrl(query) {
  return `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=15&hl=pt-BR&output=embed`;
}
